// Inspired by https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html

import classNameMixin from 'mixins/className'
import AccordionSection from 'components/AccordionSection'

import './style.scss'

export default {
  name: 'Accordion',
  props: {
    sections: {
      type: Array,
      default: null
    },
    isNavigation: {
      type: Boolean,
      default: false
    },
    modifiers: {
      type: Array,
      default: () => []
    },
    allowToggle: {
      type: Boolean,
      default: false
    },
    allowMultiple: {
      type: Boolean,
      default: false
    }
  },
  mixins: [classNameMixin],
  render (h) {
    const { sections, modifiers, isNavigation } = this
    return (
      sections
      ? <dl class={this.className(this.$options.name, modifiers)} role='presentation'>
        { sections.map((s) => (
          <AccordionSection isNavigation={isNavigation} modifiers={modifiers} section={s} />
        ))}
      </dl>
      : null
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Accordion/index.js